export const fr = {
  app: {
    name: "Tarawa",
    tagline: "Vos courses livrées chez vous",
  },
  nav: {
    home: "Accueil",
    categories: "Catégories",
    orders: "Commandes",
    cart: "Panier",
    account: "Mon compte",
  },
  common: {
    loading: "Chargement…",
    retry: "Réessayer",
    back: "Retour",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    continue: "Continuer",
    seeAll: "Voir tout",
    close: "Fermer",
    optional: "facultatif",
    language: "Langue",
    unavailable: "Indisponible",
    or: "ou",
    loadError: "Impossible de charger cette page.",
    notFound: "Page introuvable.",
    goHome: "Retour à l'accueil",
  },
  home: {
    searchPlaceholder: "Rechercher un produit…",
    categories: "Catégories",
    packs: "Packs",
    seasonal: "Produits de saison",
    featured: "À la une",
    popular: "Les plus demandés",
    hello: "Bonjour {name}",
    helloGuest: "Bonjour",
    deliveryTo: "Livraison à {city}",
    deliveryHours: "Livraison de {start} à {end}",
    deliveryOff: "La livraison est momentanément indisponible.",
    codBadge: "Paiement à la livraison",
    minOrder: "Minimum {amount}",
    fee: "Livraison {amount}",
    freeDelivery: "Livraison offerte",
    empty: "Aucun produit pour le moment.",
    heroTitle: "Le frais, livré chez vous",
    heroText: "Commandez en quelques secondes et payez en espèces à la réception.",
  },
  search: {
    title: "Recherche",
    results: "{count} résultat(s)",
    noResults: "Aucun produit trouvé pour « {q} ».",
    hint: "Tapez le nom d'un produit.",
  },
  categories: {
    title: "Catégories",
    products: "{count} produits",
    empty: "Aucun produit dans cette catégorie.",
    notFound: "Catégorie introuvable.",
    all: "Tout",
    subcategories: "Sous-catégories",
  },
  product: {
    weight: "Choisir le poids",
    addToCart: "Ajouter au panier",
    add: "Ajouter",
    added: "Ajouté au panier",
    quantity: "Quantité",
    unavailable: "Ce produit est momentanément indisponible.",
    description: "Description",
    inCart: "{count} dans le panier",
    notFound: "Produit introuvable.",
    increase: "Augmenter la quantité",
    decrease: "Diminuer la quantité",
    similar: "Produits similaires",
  },
  pack: {
    badge: "Pack",
    contents: "Contenu du pack",
    items: "{count} produits",
    unavailable: "Ce pack est momentanément indisponible.",
    notFound: "Pack introuvable.",
  },
  cart: {
    title: "Panier",
    empty: "Votre panier est vide",
    emptyHint: "Ajoutez des produits pour commencer.",
    browse: "Découvrir les produits",
    subtotal: "Sous-total",
    delivery: "Livraison",
    discount: "Réduction",
    total: "Total",
    coupon: "Code promo",
    couponPlaceholder: "Entrez votre code",
    apply: "Appliquer",
    remove: "Retirer",
    couponApplied: "Code {code} appliqué",
    checkout: "Commander",
    view: "Voir le panier",
    minOrderNotMet: "Encore {amount} pour atteindre le minimum de commande ({min}).",
    unavailableItems: "Certains produits ne sont plus disponibles. Retirez-les pour continuer.",
    each: "l'unité",
    items: "{count} article(s)",
    deliveryOff: "La livraison est momentanément indisponible.",
    orderingClosed: "Les commandes sont fermées pour le moment. Commandes acceptées de {start} à {end}.",
    closingSoon: "Les commandes ferment à {end}. Finalisez votre commande rapidement.",
    graceCheckout: "Les commandes sont fermées, mais vous avez encore quelques minutes pour finaliser celle-ci.",
    updating: "Mise à jour…",
  },
  checkout: {
    title: "Finaliser la commande",
    deliveryInfo: "Informations de livraison",
    name: "Nom",
    phone: "Téléphone",
    address: "Adresse",
    gps: "Position GPS",
    gpsSaved: "Position GPS enregistrée",
    noGps: "Non renseignée",
    chooseAddress: "Choisir l'adresse de livraison",
    addAddress: "Ajouter une nouvelle adresse",
    summary: "Récapitulatif de la commande",
    payment: "Paiement",
    cod: "Paiement à la livraison",
    codHint: "Vous payez en espèces au livreur à la réception de votre commande.",
    notes: "Note pour le livreur",
    notesPlaceholder: "Ex. : sonner à l'interphone",
    confirm: "Confirmer la commande",
    placing: "Envoi de la commande…",
    noAddress: "Ajoutez une adresse de livraison pour continuer.",
    phoneRequired: "Ajoutez et vérifiez votre numéro de téléphone : le livreur doit pouvoir vous joindre.",
    phoneRequiredNoSms: "Ajoutez votre numéro de téléphone : le livreur doit pouvoir vous joindre.",
    cartChanged: "Votre panier a changé. Vérifiez-le avant de commander.",
    backToCart: "Retour au panier",
    missingTitle: "Encore un petit détail",
    missingText: "Complétez ces informations pour finaliser votre commande. Votre panier est conservé.",
    readyTitle: "Tout est prêt",
    readyText: "Vérifiez le total puis confirmez votre commande.",
    stepPhone: "Numéro de téléphone",
    stepAddress: "Adresse de livraison",
    stepDone: "Terminé",
    addressOutside: "Cette adresse est en dehors de la zone de livraison. Choisissez-en une autre ou ajoutez-en une nouvelle.",
    outsideArea: "Hors zone de livraison",
  },
  success: {
    title: "Merci ! Commande envoyée",
    subtitle: "Votre commande a bien été reçue. Numéro de commande :",
    payOnDelivery: "À payer à la livraison",
    track: "Suivre ma commande",
    continue: "Continuer mes achats",
    sendWhatsApp: "Envoyer ma commande sur WhatsApp",
    whatsAppHint: "Si WhatsApp ne s’est pas ouvert, appuyez sur ce bouton puis sur Envoyer.",
  },
  orders: {
    title: "Mes commandes",
    current: "En cours",
    past: "Historique",
    empty: "Vous n'avez pas encore de commande.",
    order: "Commande",
    date: "Date",
    items: "Produits",
    total: "Total",
    paymentMethod: "Mode de paiement",
    paymentStatus: "Statut du paiement",
    status: "Statut de la commande",
    deliveryAddress: "Adresse de livraison",
    reorder: "Commander à nouveau",
    reordered: "Produits ajoutés au panier",
    reorderSkipped: "Indisponibles : {names}",
    reorderNone: "Aucun de ces produits n'est disponible actuellement.",
    tracking: "Suivi de la commande",
    notFound: "Commande introuvable.",
    couponUsed: "Code promo {code}",
    articles: "{count} article(s)",
    notes: "Note",
    viewOnMap: "Voir sur la carte",
  },
  orderStatus: {
    PENDING: "En attente",
    CONFIRMED: "Confirmée",
    PREPARING: "En préparation",
    OUT_FOR_DELIVERY: "En cours de livraison",
    DELIVERED: "Livrée",
    CANCELLED: "Annulée",
    DELIVERY_FAILED: "Échec de livraison",
  },
  orderStatusHint: {
    PENDING: "Nous avons reçu votre commande, elle va être confirmée.",
    CONFIRMED: "Votre commande est confirmée.",
    PREPARING: "Nous préparons vos produits.",
    OUT_FOR_DELIVERY: "Le livreur est en route.",
    DELIVERED: "Commande livrée. Bon appétit !",
    CANCELLED: "Cette commande a été annulée.",
    DELIVERY_FAILED: "Nous n'avons pas pu vous livrer. Notre équipe va vous contacter.",
  },
  paymentStatus: {
    PENDING: "En attente",
    PAID: "Payé",
    FAILED: "Non encaissé",
    CANCELLED: "Annulé",
  },
  paymentMethod: {
    CASH_ON_DELIVERY: "Paiement à la livraison",
  },
  account: {
    noPhone: "Aucun numéro vérifié",
    addPhoneTitle: "Ajoutez votre numéro de téléphone",
    addPhoneText: "Nécessaire pour la livraison. Vous recevrez un code de vérification par SMS.",
    addPhoneTextNoSms: "Nécessaire pour la livraison.",
    phoneVerified: "Numéro vérifié.",
    phoneSaved: "Numéro enregistré.",
    savePhone: "Enregistrer le numéro",
    changePhone: "Changer de numéro",
    changePhoneTitle: "Changer de numéro de téléphone",
    changePhoneText: "Votre numéro actuel reste enregistré tant que le nouveau n'est pas vérifié par SMS.",
    changePhoneTextNoSms: "Le nouveau numéro remplacera l'actuel.",
    googleTitle: "Connexion avec Google",
    googleLinkedAs: "Compte Google associé :",
    googleLinkText: "Associez votre compte Google pour vous connecter en un clic.",
    linkGoogle: "Associer mon compte Google",
    title: "Mon compte",
    personal: "Informations personnelles",
    fullName: "Nom complet",
    phone: "Téléphone",
    addresses: "Mes adresses",
    addAddress: "Ajouter une nouvelle adresse",
    default: "Par défaut",
    logout: "Se déconnecter",
    saved: "Modifications enregistrées",
    noAddress: "Aucune adresse enregistrée.",
    deleteAddressConfirm: "Supprimer cette adresse ?",
    orders: "Mes commandes",
    instagram: "Tarawa sur Instagram",
    whatsapp: "Écrire à Tarawa sur WhatsApp",
    guestTitle: "Bienvenue sur Tarawa",
    guestText: "Connectez-vous pour commander et suivre vos livraisons.",
    gpsSaved: "GPS enregistré",
  },
  privacy: {
    title: "Politique de confidentialité",
  },
  photoCredits: {
    title: "Crédits photos",
    source: "Source :",
    author: "Auteur :",
    license: "Licence :",
  },
  address: {
    newTitle: "Nouvelle adresse",
    editTitle: "Modifier l'adresse",
    label: "Nom de l'adresse",
    labelPlaceholder: "Maison, Travail…",
    line: "Adresse",
    linePlaceholder: "Rue, numéro, quartier, immeuble, étage…",
    city: "Ville",
    instructions: "Indications pour le livreur",
    instructionsPlaceholder: "Point de repère, code d'entrée…",
    manualTitle: "Adresse de livraison",
    locating: "Localisation…",
    gpsDenied: "Vous n'avez pas autorisé l'accès à votre position.",
    gpsUnavailable: "Votre position est introuvable pour le moment.",
    gpsUnsupported: "La localisation n'est pas disponible sur cet appareil.",
    outsideArea: "Désolé, nous livrons uniquement à {city}.",
    outsideAreaGps: "Cette position est en dehors de notre zone de livraison ({city}).",
    deliveryAreaInfo: "Zone de livraison : {city}",
    makeDefault: "Utiliser comme adresse par défaut",
    deleted: "Adresse supprimée",
    saved: "Adresse enregistrée",
    later: "Plus tard",
    addNowTitle: "Ajouter votre adresse de livraison",
    addNowText: "Vous pouvez l'ajouter maintenant ou plus tard, au moment de commander.",
    gpsDialogTitle: "Utiliser votre position ?",
    gpsDialogText: "Autorisez la localisation pour renseigner automatiquement votre adresse de livraison. Vous pourrez aussi saisir votre adresse manuellement.",
    gpsEnable: "Activer",
    gpsNoThanks: "Non, merci",
    gpsSaving: "Enregistrement de l'adresse…",
    gpsFailedTitle: "Position non obtenue",
    gpsTimeout: "La localisation a pris trop de temps.",
    gpsNotConfigured: "L'adresse par position GPS n'est pas encore disponible.",
    gpsAddressSaved: "Adresse enregistrée à partir de votre position",
    gpsDeniedHelp: "Autorisez la localisation pour ce site dans les réglages de votre navigateur, puis réessayez.",
    gpsInaccurate: "Position trop imprécise (± {distance}). Activez la localisation précise (GPS) de votre appareil, idéalement près d'une fenêtre ou à l'extérieur, puis réessayez.",
    gpsInvalid: "Les coordonnées reçues de votre appareil sont invalides.",
    gpsStale: "La position reçue n'était pas à jour. Réessayez.",
    gpsInsecure: "Votre navigateur n'autorise la localisation que sur une connexion sécurisée (HTTPS). Cette page est ouverte en HTTP : saisissez votre adresse manuellement.",
    enterManually: "Saisir l'adresse manuellement",
    gpsBased: "Position GPS",
  },
  auth: {
    loginTitle: "Connexion",
    loginSubtitle: "Connectez-vous avec votre numéro de téléphone.",
    phone: "Numéro de téléphone",
    phonePlaceholder: "06 12 34 56 78",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    fullName: "Nom complet",
    fullNamePlaceholder: "Ex. : Amina El Idrissi",
    login: "Se connecter",
    noAccount: "Pas encore de compte ?",
    register: "Créer un compte",
    haveAccount: "Déjà un compte ?",
    registerTitle: "Créer un compte",
    registerSubtitle: "Un code de vérification vous sera envoyé par SMS.",
    registerSubtitleNoSms: "Créez votre compte en quelques secondes.",
    passwordHint: "8 caractères minimum, avec au moins une lettre et un chiffre.",
    forgot: "Mot de passe oublié ?",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    verifyTitle: "Vérification du numéro",
    verifySubtitle: "Entrez le code à 4 chiffres envoyé par SMS au",
    verify: "Vérifier",
    resend: "Renvoyer le code",
    resendIn: "Renvoyer le code dans {s} s",
    codeSent: "Un nouveau code a été envoyé.",
    verified: "Numéro vérifié ! Bienvenue.",
    changeNumber: "Modifier le numéro",
    forgotTitle: "Mot de passe oublié",
    forgotSubtitle: "Entrez votre numéro. Si un compte existe, vous recevrez un code par SMS.",
    email: "Adresse email",
    emailPlaceholder: "vous@exemple.com",
    registerSubtitleEmail: "Un code de vérification vous sera envoyé par email.",
    verifyEmailTitle: "Vérification de l'email",
    verifyEmailSubtitle: "Entrez le code à 6 chiffres envoyé à",
    emailVerified: "Email vérifié ! Bienvenue.",
    changeEmail: "Modifier l'adresse email",
    forgotSubtitleEmail: "Entrez l'adresse email de votre compte. Si un compte existe, vous recevrez un code par email.",
    resetCodeSubtitleEmail: "Si cette adresse est associée à un compte, un code à 6 chiffres a été envoyé à",
    recoveryUnavailable:
      "Mot de passe oublié ? Contactez-nous sur WhatsApp et nous vous aiderons à retrouver l’accès à votre compte. Si votre compte est associé à Google, vous pouvez aussi vous connecter avec Google.",
    contactWhatsApp: "Nous contacter sur WhatsApp",
    sendCode: "Recevoir un code",
    resetCodeTitle: "Code de vérification",
    resetCodeSubtitle: "Si ce numéro est associé à un compte, un code à 4 chiffres a été envoyé au",
    newPasswordTitle: "Nouveau mot de passe",
    newPassword: "Nouveau mot de passe",
    resetDone: "Mot de passe modifié. Connectez-vous avec votre nouveau mot de passe.",
    savePassword: "Enregistrer le mot de passe",
    loggedOut: "Vous êtes déconnecté.",
    welcomeBack: "Bon retour, {name} !",
    otpLabel: "Code de vérification",
    attemptsLeft: "{n} tentative(s) restante(s).",
    loginRequired: "Connectez-vous pour continuer.",
    continueWithGoogle: "Continuer avec Google",
    signUpWithGoogle: "S'inscrire avec Google",
    googleRedirecting: "Redirection vers Google…",
    googleSignedIn: "Connecté avec Google.",
    googleWelcome: "Bienvenue sur Tarawa ! Un numéro de téléphone vérifié vous sera demandé lors de votre première commande.",
    googleLinked: "Votre compte Google est associé.",
  },
  errors: {
    generic: "Une erreur est survenue. Réessayez.",
    network: "Connexion impossible. Vérifiez votre connexion internet.",
    VALIDATION_ERROR: "Veuillez corriger les champs indiqués.",
    INVALID: "Valeur invalide.",
    TOO_LONG: "Texte trop long.",
    PHONE_REQUIRED: "Entrez votre numéro de téléphone.",
    PHONE_INVALID: "Numéro marocain invalide (ex. : 06 12 34 56 78).",
    NAME_REQUIRED: "Entrez votre nom complet.",
    NAME_TOO_SHORT: "Entrez votre nom complet.",
    NAME_TOO_LONG: "Nom trop long.",
    PASSWORD_REQUIRED: "Entrez votre mot de passe.",
    PASSWORD_TOO_SHORT: "Le mot de passe doit contenir au moins 8 caractères.",
    PASSWORD_TOO_LONG: "Mot de passe trop long.",
    PASSWORD_TOO_WEAK: "Le mot de passe doit contenir au moins une lettre et un chiffre.",
    PASSWORDS_DO_NOT_MATCH: "Les mots de passe ne correspondent pas.",
    PHONE_ALREADY_REGISTERED: "Ce numéro est déjà associé à un compte. Connectez-vous.",
    PHONE_NOT_VERIFIED: "Votre numéro n'est pas encore vérifié. Entrez le code reçu par SMS.",
    INVALID_CREDENTIALS: "Numéro ou mot de passe incorrect.",
    LOGIN_LOCKED: "Trop de tentatives. Réessayez dans quelques minutes.",
    ACCOUNT_DISABLED: "Ce compte est désactivé. Contactez-nous.",
    OTP_REQUIRED: "Entrez le code reçu par SMS.",
    OTP_INVALID: "Code incorrect.",
    OTP_EXPIRED: "Ce code a expiré. Demandez un nouveau code.",
    OTP_TOO_MANY_ATTEMPTS: "Trop de tentatives. Demandez un nouveau code.",
    OTP_RESEND_TOO_SOON: "Patientez un peu avant de demander un nouveau code.",
    OTP_TOO_MANY_REQUESTS: "Trop de codes demandés. Réessayez plus tard.",
    SMS_SEND_FAILED: "L'envoi du SMS a échoué. Réessayez dans un instant.",
    REGISTRATION_EXPIRED: "Votre inscription a expiré. Recommencez.",
    RESET_TOKEN_INVALID: "Cette demande n'est plus valide. Recommencez.",
    PASSWORD_RECOVERY_UNAVAILABLE: "La réinitialisation du mot de passe est momentanément indisponible. Contactez-nous.",
    EMAIL_REQUIRED: "Entrez votre adresse email.",
    EMAIL_INVALID: "Adresse email invalide.",
    EMAIL_ALREADY_REGISTERED: "Cette adresse email est déjà associée à un compte. Connectez-vous.",
    EMAIL_NOT_VERIFIED: "Votre adresse email n'est pas encore vérifiée. Entrez le code reçu par email.",
    EMAIL_SEND_FAILED: "L'envoi de l'email a échoué. Réessayez dans un instant.",
    EMAIL_DAILY_LIMIT_REACHED: "Le service d'envoi d'emails est momentanément saturé. Réessayez plus tard.",
    REGISTRATION_CONFLICT: "Une inscription est déjà en cours avec ces informations. Réessayez.",
    RATE_LIMITED: "Trop de demandes. Réessayez dans un instant.",
    UNAUTHENTICATED: "Veuillez vous connecter.",
    OUTSIDE_DELIVERY_AREA: "Adresse en dehors de la zone de livraison.",
    ADDRESS_REQUIRED: "Choisissez une adresse de livraison.",
    ADDRESS_TOO_SHORT: "Adresse trop courte, ajoutez des détails.",
    ADDRESS_NOT_FOUND: "Adresse introuvable.",
    CITY_REQUIRED: "Entrez la ville.",
    GPS_INVALID: "Position GPS invalide.",
    TOO_MANY_ADDRESSES: "Nombre maximum d'adresses atteint.",
    PRODUCT_UNAVAILABLE: "Ce produit n'est plus disponible.",
    PACK_UNAVAILABLE: "Ce pack n'est plus disponible.",
    WEIGHT_INVALID: "Ce poids n'est pas proposé pour ce produit.",
    PRODUCTS_UNAVAILABLE: "Certains produits ne sont plus disponibles. Votre panier a été mis à jour.",
    QUANTITY_TOO_HIGH: "Quantité maximale atteinte.",
    CART_EMPTY: "Votre panier est vide.",
    CART_FULL: "Votre panier est plein.",
    MIN_ORDER_NOT_MET: "Le montant minimum de commande n'est pas atteint.",
    DELIVERY_UNAVAILABLE: "La livraison est momentanément indisponible.",
    ORDERING_CLOSED: "Les commandes sont fermées pour le moment. Commandes acceptées de {start} à {end}.",
    COUPON_INVALID: "Code promo invalide.",
    COUPON_EXPIRED: "Ce code promo a expiré.",
    COUPON_MIN_ORDER: "Ce code est valable à partir de {amount} d'achat.",
    COUPON_USAGE_LIMIT_REACHED: "Ce code promo n'est plus disponible.",
    PAYMENT_METHOD_INVALID: "Seul le paiement à la livraison est accepté.",
    ORDER_NOT_FOUND: "Commande introuvable.",
    GPS_AREA_NOT_CONFIGURED: "L'adresse par position GPS n'est pas encore disponible. Saisissez votre adresse.",
    NOT_FOUND: "Introuvable.",
    PHONE_UNCHANGED: "C'est déjà votre numéro actuel.",
    PHONE_CHANGE_CONFLICT: "Votre numéro a été modifié entre-temps. Rechargez la page et réessayez.",
    PHONE_VERIFICATION_REQUIRED: "Ajoutez et vérifiez votre numéro de téléphone avant de commander.",
    GOOGLE_AUTH_UNAVAILABLE: "La connexion avec Google n'est pas disponible pour le moment.",
    GOOGLE_CANCELLED: "Connexion avec Google annulée.",
    GOOGLE_STATE_INVALID: "La connexion avec Google n'a pas pu être vérifiée. Réessayez.",
    GOOGLE_STATE_EXPIRED: "La connexion avec Google a expiré. Réessayez.",
    GOOGLE_FAILED: "La connexion avec Google a échoué. Réessayez.",
    GOOGLE_TOKEN_INVALID: "La réponse de Google n'a pas pu être vérifiée. Réessayez.",
    GOOGLE_EMAIL_NOT_VERIFIED: "L'adresse e-mail de ce compte Google n'est pas vérifiée.",
    GOOGLE_ACCOUNT_IN_USE: "Ce compte Google est déjà associé à un autre compte Tarawa.",
    GOOGLE_ALREADY_LINKED: "Un compte Google est déjà associé à ce compte.",
    GOOGLE_LINK_SESSION_INVALID: "Votre session a changé pendant l'association. Reconnectez-vous et réessayez.",
  },
};

export type Dictionary = typeof fr;
